export const API_URLS = {
	GET_SUPPORT_ITEMS: "admin/workspace/help"
};
